(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["md-advent-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.md-advent');

    sections.forEach((section) => {
      if (section.dataset.mdReady === 'true') return;
      section.dataset.mdReady = 'true';

      const sticky = section.querySelector('[data-md-sticky]');
      const purchaseForm =
        document.querySelector('product-form form[action*="/cart/add"]') ||
        document.querySelector('form[action*="/cart/add"]');
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const scrollToBuy = () => {
        if (!purchaseForm) return;
        purchaseForm.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'center' });
        window.setTimeout(() => {
          const firstControl = purchaseForm.querySelector('input:not([type="hidden"]), select, button');
          if (firstControl) firstControl.focus({ preventScroll: true });
        }, prefersReducedMotion ? 0 : 650);
      };

      section.querySelectorAll('[data-md-scroll-buy]').forEach((button) => {
        button.addEventListener('click', scrollToBuy);
      });

      if (!prefersReducedMotion && 'IntersectionObserver' in window) {
        section.dataset.mdMotion = 'true';
        const revealObserver = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('md-advent__is-visible');
              observer.unobserve(entry.target);
            });
          },
          { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
        );

        section.querySelectorAll('[data-md-reveal]').forEach((item) => {
          revealObserver.observe(item);
        });
      }

      if (!sticky || !purchaseForm || !('IntersectionObserver' in window)) return;

      const observer = new IntersectionObserver(
        ([entry]) => {
          sticky.hidden = entry.isIntersecting;
        },
        { rootMargin: '-15% 0px -45% 0px' }
      );

      observer.observe(purchaseForm);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["md-monthly-edition"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-md-monthly-edition]').forEach((section) => {
    const items = section.querySelectorAll('.md-monthly-edition__reveal');
    if (!('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }
    section.classList.add('is-motion-ready');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    items.forEach((item, index) => {
      item.style.transitionDelay = `${Math.min(index * 70, 280)}ms`;
      observer.observe(item);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["md-monthly-evergreen"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-md-monthly-evergreen]').forEach((section) => {
    const items = section.querySelectorAll('.md-monthly-evergreen__reveal');
    if (!('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
    } else {
      section.classList.add('is-motion-ready');
      const revealObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.08 });
      items.forEach((item) => revealObserver.observe(item));
    }

    const sticky = section.querySelector('[data-mdm-sticky]');
    if (!sticky) return;
    const target = document.getElementById(sticky.dataset.target);
    if (!target || !('IntersectionObserver' in window)) return;
    const stickyObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        sticky.classList.toggle('is-visible', entry.boundingClientRect.bottom < 0);
      });
    }, { threshold: 0.05 });
    stickyObserver.observe(target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["md-monthly-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-md-monthly-hero]').forEach((section) => {
    const items = section.querySelectorAll('.md-monthly-reveal');
    if (!('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
    } else {
      section.classList.add('is-motion-ready');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
      items.forEach((item) => observer.observe(item));
    }

    const detailsUrl = section.dataset.mdSubscriptionDetailsUrl;
    const buyArea = section.querySelector('[data-mdm-buy]');

    if (buyArea && detailsUrl) {
      const updateDetailsLink = () => {
        buyArea.querySelectorAll('.sls-subscription-details-label a').forEach((link) => {
          link.href = detailsUrl;
          link.removeAttribute('target');
          link.removeAttribute('rel');
        });
      };

      updateDetailsLink();
      const detailsObserver = new MutationObserver(updateDetailsLink);
      detailsObserver.observe(buyArea, { childList: true, subtree: true });
    }

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["melt-forward-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('melt-forward-banner')) {
    class MeltForwardBanner extends HTMLElement {
      connectedCallback() {
        if (this.running) return;
        this.running = true;
        this.endsAt = Date.parse(this.dataset.endsAt);
        this.variantId = String(this.dataset.variantId);
        this.setActive(false);
        this.onVisibility = () => {
          this.setActive(false);
          this.cancelRequest();
          clearTimeout(this.pollTimer);
          if (document.visibilityState === 'visible') this.refresh();
        };
        this.onPageShow = () => this.onVisibility();
        document.addEventListener('visibilitychange', this.onVisibility);
        window.addEventListener('pageshow', this.onPageShow);
        if (!this.inTime()) return;
        this.expiryTimer = setTimeout(() => {
          this.setActive(false);
          clearTimeout(this.pollTimer);
          this.cancelRequest();
        }, this.endsAt - Date.now());
        this.refresh();
      }

      disconnectedCallback() {
        this.running = false;
        this.setActive(false);
        this.cancelRequest();
        clearTimeout(this.pollTimer);
        clearTimeout(this.expiryTimer);
        document.removeEventListener('visibilitychange', this.onVisibility);
        window.removeEventListener('pageshow', this.onPageShow);
      }

      inTime() {
        return Number.isFinite(this.endsAt) && Date.now() < this.endsAt;
      }

      setActive(active) {
        this.hidden = !active;
        this.dataset.active = String(active);
      }

      cancelRequest() {
        if (this.controller) this.controller.abort();
        this.controller = null;
        clearTimeout(this.requestTimer);
      }

      async refresh() {
        clearTimeout(this.pollTimer);
        if (!this.running || !this.inTime() || document.visibilityState !== 'visible') {
          this.setActive(false);
          return;
        }
        this.cancelRequest();
        const controller = new AbortController();
        this.controller = controller;
        this.requestTimer = setTimeout(() => {
          if (this.controller === controller) {
            this.setActive(false);
            controller.abort();
          }
        }, 5000);
        try {
          const url = new URL(this.dataset.productUrl, window.location.origin);
          url.searchParams.set('_melt_forward', String(Date.now()));
          const response = await fetch(url.toString(), {
            credentials: 'same-origin',
            cache: 'no-store',
            signal: controller.signal,
            headers: { Accept: 'application/json' }
          });
          if (!response.ok) throw new Error('Product unavailable');
          const product = await response.json();
          if (this.controller !== controller || controller.signal.aborted) return;
          const available = Array.isArray(product.variants) && product.variants.some(
            (variant) => String(variant.id) === this.variantId && variant.available === true
          );
          this.setActive(this.running && this.inTime() && document.visibilityState === 'visible' && available);
        } catch (error) {
          if (this.controller === controller) this.setActive(false);
        } finally {
          if (this.controller === controller) {
            clearTimeout(this.requestTimer);
            this.controller = null;
            if (this.running && this.inTime() && document.visibilityState === 'visible') {
              this.pollTimer = setTimeout(() => this.refresh(), 10000);
            }
          }
        }
      }
    }
    customElements.define('melt-forward-banner', MeltForwardBanner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["melt-product-scroll-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('melt-scroll-video')) {
    customElements.define(
      'melt-scroll-video',
      class MeltScrollVideo extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('video');

          if (!this.video || this.initialized) return;

          this.initialized = true;
          this.inView = false;
          this.pausedByObserver = true;
          this.autoAction = false;
          this.manualOnly = false;
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.saveData = Boolean(navigator.connection && navigator.connection.saveData);

          this.handlePause = this.handlePause.bind(this);
          this.handlePlay = this.handlePlay.bind(this);
          this.handleVolumeChange = this.handleVolumeChange.bind(this);
          this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
          this.handleReducedMotionChange = this.handleReducedMotionChange.bind(this);
          this.handleAnotherVideo = this.handleAnotherVideo.bind(this);

          this.video.addEventListener('pause', this.handlePause);
          this.video.addEventListener('play', this.handlePlay);
          this.video.addEventListener('volumechange', this.handleVolumeChange);
          document.addEventListener('visibilitychange', this.handleVisibilityChange);
          document.addEventListener('melt:product-video-play', this.handleAnotherVideo);
          this.reducedMotion.addEventListener('change', this.handleReducedMotionChange);

          if (!('IntersectionObserver' in window)) return;

          this.visibilityObserver = new IntersectionObserver(
            (entries) => {
              const ratio = entries[0].intersectionRatio;

              if (ratio >= 0.3) {
                this.inView = true;
                this.playIfAllowed();
              } else if (ratio <= 0.15) {
                this.inView = false;
                this.pauseForObserver();
              }
            },
            { threshold: [0, 0.15, 0.3] }
          );

          this.visibilityObserver.observe(this.video);
        }

        disconnectedCallback() {
          if (!this.initialized) return;

          this.visibilityObserver?.disconnect();
          this.video.removeEventListener('pause', this.handlePause);
          this.video.removeEventListener('play', this.handlePlay);
          this.video.removeEventListener('volumechange', this.handleVolumeChange);
          document.removeEventListener('visibilitychange', this.handleVisibilityChange);
          document.removeEventListener('melt:product-video-play', this.handleAnotherVideo);
          this.reducedMotion.removeEventListener('change', this.handleReducedMotionChange);
        }

        canAutoplay() {
          const isThemeEditor = Boolean(window.Shopify && window.Shopify.designMode);

          return (
            !isThemeEditor &&
            !this.reducedMotion.matches &&
            !this.saveData &&
            !this.manualOnly &&
            !document.hidden
          );
        }

        playIfAllowed() {
          if (!this.video.paused || !this.inView || !this.pausedByObserver || !this.canAutoplay()) return;

          document.dispatchEvent(new CustomEvent('melt:product-video-play', { detail: this }));
          this.autoAction = true;
          const playPromise = this.video.play();

          if (playPromise) {
            playPromise.catch(() => {}).finally(() => {
              this.autoAction = false;
            });
          } else {
            this.autoAction = false;
          }
        }

        pauseForObserver() {
          if (this.video.paused) return;

          this.autoAction = true;
          this.pausedByObserver = true;
          this.video.pause();
          this.autoAction = false;
        }

        handlePause() {
          if (!this.autoAction && this.inView && !this.video.ended) {
            this.pausedByObserver = false;
          }
        }

        handlePlay() {
          if (!this.autoAction) {
            this.pausedByObserver = false;
          }
        }

        handleVolumeChange() {
          if (!this.video.muted) {
            this.manualOnly = true;
          }
        }

        handleVisibilityChange() {
          if (document.hidden) {
            this.pauseForObserver();
          } else {
            this.playIfAllowed();
          }
        }

        handleReducedMotionChange(event) {
          if (event.matches) {
            this.pauseForObserver();
          } else {
            this.playIfAllowed();
          }
        }

        handleAnotherVideo(event) {
          if (event.detail !== this) {
            this.pauseForObserver();
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
